export default function setupKeyboardListeners(vm) {
    let command = null;
    const keyboardChannel = new BroadcastChannel('pdv_keyboard');

    const keyCombo = (event) => {
        if (['Control', 'Shift', 'Alt', 'Meta'].includes(event.key)) return null;
        return [
            event.ctrlKey && 'ctrl',
            event.shiftKey && 'shift',
            event.altKey && 'alt',
            event.metaKey && 'meta',
            event.key.toLowerCase()
        ]
            .filter(Boolean)
            .join('+');
    };

    fetch('/api/keyboard-config')
        .then(response => response.json())
        .then(data => {
            const buttons = data.buttons;
            const settings = data.settings;
            const shortcuts = {};

            buttons.forEach((btn, index) => {
                const func = settings[index]?.function;
                const parsed = parseFunction(func);

                if (parsed) {
                    shortcuts[btn.command] = parsed;

                } else {
                    if (!btn.arrow) {
                        console.warn(`Função não mapeada: ${btn.command} | Coluna: ${btn.col} | Linha: ${btn.row}`);
                    }


                }
            });

            window.addEventListener("keydown", (event) => {
                console.log(event.key)
                const combo = keyCombo(event);

                // Atalho fixo para F16
                if (combo === 'f16') {
                    if (typeof vm.searchProduct === 'function') {
                        vm.searchProduct("999");
                    }
                    return;
                }

                // Atalho fixo para F17
                if (combo === 'f17') {
                    if (typeof vm.searchProduct === 'function') {
                        vm.searchProduct("6920897700644");
                    }
                    return;
                }

                // Atalho fixo para F18
                if (combo === 'f18') {
                    if (typeof vm.searchProduct === 'function') {
                        vm.searchProduct("c49");
                    }
                    return;
                }

                if (combo !== null) {
                    console.log(`Tecla pressionada: ${combo}`);
                }

                if (combo && shortcuts[combo]) {
                    event.preventDefault();
                    command = combo;
                    shortcuts[combo]();
                }
            });

            keyboardChannel.onmessage = function (event) {
                const data = event.data;
                if (data.command && shortcuts[data.command]) {
                    console.log(`Comando recebido via canal: ${data.command}`);
                    shortcuts[data.command]();
                }
            };
        })
        .catch(error => {
            console.error('Erro ao carregar configurações do teclado:', error);
        });

    function parseFunction(fnString) {
        try {
            if (!fnString) return null;
            const match = fnString.match(/^([a-zA-Z0-9_]+)\((.*)\)$/);
            if (match) {
                const funcName = match[1];
                const paramStr = match[2];
                const params = paramStr
                    ? paramStr.split(',').map(p => {
                        const trimmed = p.trim();
                        if (!isNaN(trimmed)) {
                            return Number(trimmed);
                        }
                        return trimmed.replace(/^['"]|['"]$/g, '');
                    })
                    : [];
                if (typeof vm[funcName] === 'function') {
                    return () => vm[funcName](...params);
                }
            } else {
                const funcName = fnString.trim();
                if (typeof vm[funcName] === 'function') {
                    return () => vm[funcName]();
                }
            }
        } catch (e) {
            console.error('Erro ao parsear função:', fnString, e);
        }
        return null;
    }
}
